import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';
import { INode } from '@cbridge-packages/node';
import { IStream, IStreamForm } from './stream.interface';

export namespace StreamAction {
  const actionCreator = actionCreatorFactory('Stream');

  export const loadList = actionCreator.async<{ nodeId: INode['nodeId'] }, IStream[], IApiErrorParams>('LOAD_LIST');
  export const load = actionCreator.async<{ streamId: IStream['streamId'] }, IStream, IApiErrorParams>('LOAD');

  export const create = actionCreator.async<IStreamForm, { streamId: IStream['streamId'] }, void>('CREATE');
  export const update = actionCreator.async<IStreamForm, void, void>('UPDATE');
  export const remove = actionCreator.async<{ streamId: IStream['streamId'] }, void, void>('REMOVE');

  export const reload = actionCreator('RELOAD');
  export const processing = actionCreator.async<void, void, void>('PROCESSING');

  export const destroy = actionCreator('DESTROY');
}
